import { FaFacebookF } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaGoogleDrive } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
export const socialmedias = [
  { icon: <FaFacebookF />, to: "/" },
  { icon: <FaLinkedinIn />, to: "/" },
  { icon: <FaYoutube />, to: "/" },
  { icon: <FaGoogleDrive />, to: "/" },
  { icon: <FaTwitter />, to: "/" },
];

export const footerLinks = [
  {
    category: "Company",
    links: [
      {
        link: "About us",
        to: "/about-us",
      },
      {
        link: "Our journey",
        to: "/our_journey",
      },
      {
        link: "Leadership team",
        to: "/leadership_team",
      },
      {
        link: "Contact",
        to: "/contact",
      },
      {
        link: "Careers",
        to: "/careers",
      },
      {
        link: "What's new",
        to: "/whats_new",
      },
      {
        link: "Trust center",
        to: "/trust_center",
      },
    ],
  },
  {
    category: "Platform",
    links: [
      {
        link: "Data Collection & Analysis",
        to: "/datacollection",
      },
      {
        link: "Enterprise Solutions",
        to: "/enterprise_solutions",
      },
      {
        link: "Workflows",
        to: "/workflows",
      },
      {
        link: "Machine Learning",
        to: "/machine_learning",
      },
      {
        link: "Business Apps",
        to: "/business_apps",
      },
      {
        link: "Multimodal",
        to: "/multimodal",
      },
      {
        link: "Build Custom AI",
        to: "/build-custom-ai",
      },
    ],
  },
  {
    category: "Services",
    links: [
      {
        link: "Blog",
        to: "/blog",
      },
      {
        link: "Press",
        to: "/press",
      },
      {
        link: "Brand",
        to: "/brand",
      },
      {
        link: "Changelog",
        to: "/changelog",
      },
      {
        link: "Support",
        to: "/support",
      },
      {
        link: "Privacy",
        to: "/privacy",
      },
      {
        link: "Webinars & Events",
        to: "/webinars",
      },
    ],
  },
  {
    category: "Community",
    links: [
      {
        link: "Explore",
        to: "/explore",
      },
      {
        link: "Bot Connector",
        to: "/bot_connector",
      },
      {
        link: "Join Us",
        to: "/join_us",
      },
      {
        link: "Github",
        to: "/github",
      },
      {
        link: "Meetups",
        to: "/meetups",
      },
      {
        link: "Workshop",
        to: "/workshop",
      },
    ],
  },
  {
    category: "API",
    links: [
      {
        link: "Documentation",
        to: "/documentation",
      },
      {
        link: "Roadmap",
        to: "/roadmap",
      },
      {
        link: "Pricing",
        to: "/pricing",
      },
      {
        link: "Serverstatus",
        to: "/serverstatus",
      },
      {
        link: "Research",
        to: "/research",
      },
      {
        link: "Tools",
        to: "/tools",
      },
    ],
  },
];

export const Company = [
  {
    link: "About us",
    to: "/about-us",
  },
  {
    link: "Our journey",
    to: "/our_journey",
  },
  {
    link: "Leadership team",
    to: "/leadership_team",
  },
  {
    link: "Contact",
    to: "/contact",
  },
  {
    link: "Careers",
    to: "/careers",
  },
  {
    link: "What's new",
    to: "/whats_new",
  },
  {
    link: "Trust center",
    to: "/",
  },
];
export const Platform = [
  {
    link: "Data Collection & Analysis",
    to: "/datacollection",
  },
  {
    link: "Enterprise Solutions",
    to: "/enterprise_solutions",
  },
  {
    link: "Workflows",
    to: "/workflows",
  },
  {
    link: "Machine Learning",
    to: "/machine_learning",
  },
  {
    link: "Business Apps",
    to: "/Blog",
  },
  {
    link: "Multimodal",
    to: "/multimodal",
  },
  {
    link: "Build Custom AI",
    to: "/build-custom-ai",
  },
];
export const Services = [
  {
    link: "Blog",
    to: "/blog",
  },
  {
    link: "Press",
    to: "/press",
  },
  {
    link: "Brand",
    to: "/brand",
  },
  {
    link: "Changelog",
    to: "/changelog",
  },
  {
    link: "Support",
    to: "/support",
  },
  {
    link: "Privacy",
    to: "/privacy",
  },
  {
    link: "Webinars & Events",
    to: "/webinars",
  },
];
export const community = [
  {
    link: "Explore",
    to: "/explore",
  },
  {
    link: "Bot Connector",
    to: "/bot_connector",
  },
  {
    link: "Join Us",
    to: "/join_us",
  },
  {
    link: "Github",
    to: "/github",
  },
  {
    link: "Meetups",
    to: "/meetups",
  },
  {
    link: "Workshop",
    to: "/workshop",
  },
];

export const api = [
  {
    link: "Documentation",
    to: "/documentation",
  },
  {
    link: "Roadmap",
    to: "/roadmap",
  },
  {
    link: "Pricing",
    to: "/pricing",
  },
  {
    link: "Serverstatus",
    to: "/serverstatus",
  },
  {
    link: "Research",
    to: "/research",
  },
  {
    link: "Tools",
    to: "/tools",
  },
];
